import { useDispatch, useSelector } from "react-redux";
import { setPostions } from "../../store/slice/application";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import RenderField from "../RenderField";
import { useEffect, useMemo, useState } from "react";
import countryList from "react-select-country-list";

const SelectedPostions = ({ positions, handlePostionClick, register, errors, watch, setValue, control, setRwanda, rwanda }) => {
    const { postions } = useSelector((state) => state.application);
    const options = useMemo(() => countryList().getData(), []);
    const [selectedPositions, setSelectedPositions] = useState(postions);

    const dispatch = useDispatch();
    const internationalPositions = positions?.filter((position) => position.international)
    const availablePositions = rwanda ? positions : internationalPositions


    const handleSelect = (postion) => {

    
        if (selectedPositions.filter(item => item.id === postion.id).length > 0) {
            setSelectedPositions(selectedPositions.filter(item => item.id !== postion.id))
            dispatch(setPostions(selectedPositions.filter(item => item.id !== postion.id)))
        } else {
            handlePostionClick(postion);
        
        }
    }

    return (
        <div className={`w-full flex flex-col justify-center items-start py-10 ${selectedPositions.length===0?'':'px-4 pt-8'} `}>

            <div className="flex flex-col gap-2.5 px-2 w-full md:w-1/2">
                {positions && selectedPositions.map((postion, index) => {

                    return (
                        <div
                            className={`flex items-center cursor-pointer relative}`}
                            onClick={() => handleSelect(postion)}
                        >
                            <input
                                type="radio"
                                checked={selectedPositions.filter(item => item.id === postion.id).length > 0 || postions.filter(item => item.id === postion.id).length > 0}
                                onChange={() => handleSelect(postion)}
                                style={{
                                    cursor: "pointer",     
                                   outline: "none",
                            accentColor: "#054166",
                                   height:"18px",
                                      width:"18px",
                                  
                                   }}
                                className="mr-2 border-2 rounded border-red-800 cursor-pointer 
    border-3 border-rose-500 rounded-lg checked:bg-rose-600"
                            />
                            <span className="text-[15px] md:text-[18px] text-normal">{postion.name}</span>
                        </div>
                    )})}
            </div>
        </div>
    );
}

export default SelectedPostions;
